import { AxiosInstance } from 'axios';

let accessToken: string | undefined;

/** Token do portal (gov.br) injetado pelo shell via Webgate. */
export function setApiAccessToken(token?: string) {
  accessToken = token;
}

export function registerInterceptors(instance: AxiosInstance) {
  instance.interceptors.request.use((config) => {
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
  );
}
